import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import RenderIf from '../../../../renderIf/RenderIf';
import useStyles from './styles';

const MUISelect = ({ label, options, value, handleChange, isMultipleSelection, isDisabled }) => {
    const classes = useStyles();
    return (
        <FormControl
            sx={{ m: 1, minWidth: 120 }}
            size="small"
        >
            <InputLabel
                id={`${label}-label`}
                sx={{ fontSize: '16px' }}
            >
                {label}
            </InputLabel>
            <Select
                label={label}
                labelId={`${label}-label`}
                id={`${label}-select`}
                value={value}
                onChange={(e) => handleChange(e, label)}
                className={classes.selectStyle}
                multiple={isMultipleSelection}
                IconComponent={(props) => (
                    <FontAwesomeIcon
                        {...props}
                        icon={faAngleDown}
                    />
                )}
                disabled={isDisabled}
            >
                {options.map((option) => (
                    <MenuItem
                        key={`option-${option.value}`}
                        value={option.value}
                        disabled={isDisabled}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>

            <RenderIf isTrue={value.length > 0}>
                <Button
                    onClick={() => handleChange('', label)}
                    sx={{ color: (theme) => theme.palette.primary.main, fontSize: '10px', fontWeight: 600, maxWidth: 120 }}
                >
                    Clear filters
                </Button>
            </RenderIf>
        </FormControl>
    );
};

export default MUISelect;
